/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import FormField from "../../../../../components/FormField";
import SelectField from "../../../../../components/SelectField";
import SoftBox from "../../../../../components/SoftBox";
import SoftTypography from "../../../../../components/SoftTypography";
import { Grid } from "@mui/material";
import FileField from "../../../../../components/FileUploadField";
import { CompanyService } from "../../../../../services/companyService";

export default function Fields({ formData }) {
  const { id } = useParams();
  const location = useLocation();
  const containEdit = location.pathname?.includes("/edit");
  const containCreate = location.pathname?.includes("/create");
  const [companyOptions, setCompanyOptions] = useState([]);
  const { formField, values, errors, touched, setFieldValue } = formData;
  const { name, email, phone, address, avatar, company } = formField;
  const {
    avatar: avatarV,
    name: nameV,
    email: emailV,
    phone: phoneV,
    address: addressV,
    company: companyV,
  } = values;

  useEffect(() => {
    (async () => {
      const { data } = await CompanyService.getAll();
      const arr = data.map((item) => ({ value: item._id, label: item.name }));
      setCompanyOptions(arr);
    })();
  }, []);
  return (
    <SoftBox>
      <SoftBox lineHeight={0}>
        <SoftTypography variant="h5" fontWeight="bold">
          {id ? (containEdit ? "Cập nhật" : "Chi tiết") : "Tạo"} nhân viên
        </SoftTypography>
      </SoftBox>
      <SoftBox mt={1} maxWidth={150}>
        <FileField
          name={avatar.name}
          label={avatar.label}
          error={errors.avatar && touched.avatar}
          success={avatarV && Object.keys(avatarV).length > 0 && !errors.avatar}
        />
      </SoftBox>

      <SoftBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={name.type}
              label={name.label}
              name={name.name}
              value={nameV}
              placeholder={name.placeholder}
              error={errors.name && touched.name}
              success={nameV.length > 0 && !errors.name}
            />
          </Grid>
          <Grid item xs={12} md={6} style={{ paddingTop: "0px" }}>
            <SelectField
              options={companyOptions}
              type={company.type}
              label={company.label}
              name={company.name}
              value={companyV}
              placeholder={company.placeholder}
              error={errors.company && touched.company}
              success={companyV.length > 0 && !errors.company}
            />
          </Grid>

          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={email.type}
              label={email.label}
              name={email.name}
              value={emailV}
              placeholder={email.placeholder}
              error={errors.email && touched.email}
              success={emailV.length > 0 && !errors.email}
              disabled={!containCreate}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={phone.type}
              label={phone.label}
              name={phone.name}
              value={phoneV}
              placeholder={phone.placeholder}
              error={errors.phone && touched.phone}
              success={phoneV.length > 0 && !errors.phone}
            />
          </Grid>

          <Grid item xs={12} style={{ paddingTop: "0px" }}>
            <FormField
              type={address.type}
              label={address.label}
              name={address.name}
              value={addressV}
              placeholder={address.placeholder}
              error={errors.address && touched.address}
              success={addressV.length > 0 && !errors.address}
            />
          </Grid>
        </Grid>
      </SoftBox>
    </SoftBox>
  );
}
